import {useRouterQuery} from 'js/v-hook/use-router';

let globalPidRef;

export function usePid() {
    if (globalPidRef) {
        globalPidRef.value = useRouterQuery('pid').value || globalPidRef.value;
    } else {
        globalPidRef = useRouterQuery('pid');
    }

    return globalPidRef;
}
